import { useRef, useEffect, useState } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import ResizeObserver from 'resize-observer-polyfill';
import AudiHeader from './audi/AudiHeader';
import AudiFooter from './audi/AudiFooter';
import Header from './Header';
import {
    APPLICATION_CONTAINER_ID,
    UI_NONE,
    UI_AUDI,
    UI_AUDI_MIN,
    UI_AUDI_DEALER,
    UI_MYAUDI,
    UI_MYAUDI_DEALER,
    DEFAULT_THEME,
} from '../constants';

const mapStateToProps = state => {
    return {
        currentDealer: state.dealers && state.dealers.current
    };
}

const Layout = ({ children, ui = UI_NONE, className = "", embedded = false, theme = DEFAULT_THEME, currentDealer }) => {

    const refContent = useRef(null);
    const initialURLRef = useRef(null);
    const [isIframed, setIsIframed] = useState(false);

    const handleResize = () => {
        var appHeight = document.getElementById(APPLICATION_CONTAINER_ID).offsetHeight + 50;
        var pxHeight = appHeight + "px";
        // URL cannot change, any requests with a new URL will be ignored
        window.parent.postMessage(JSON.stringify({
            height: pxHeight,
            url: initialURLRef.current,
        }), "*");
        window.parent.postMessage(JSON.stringify({
            height: appHeight,
            url: initialURLRef.current,
        }), "*");
        console.log('height', appHeight, initialURLRef.current);
    }

    useEffect(() => {
        initialURLRef.current = window.location.href;
        let f = typeof window !== "undefined" && window.self !== window.top;
        setIsIframed(f);
        if (typeof onDetectIframe === "function") { onDetectIframe(f); }
        if (f) {
            // Send the initial height to the parent iframe
            handleResize();
            const obs = new ResizeObserver(handleResize);
            obs.observe(refContent.current);
            return () => {
                obs.unobserve(refContent.current);
            }
        }
    }, []);

    return (
        <div ref={refContent} className={cn("audi-forms__layout", ui, className, {'embedded': embedded || isIframed, "theme-light": theme === "light", "theme-dark": theme === "dark"})}>
            {ui === UI_AUDI_DEALER && <Helmet>
                <style type="text/css">{`
                    html {font-size: 16px !important;}
                    .audi-forms__layout.audi-dealer {font-size: 16px;}
                `}</style>
            </Helmet>}
            <div className="audi-forms__layout-inner">
                {(ui === UI_AUDI || ui === UI_AUDI_MIN) && !isIframed && <AudiHeader api={process.env.RAZZLE_CMS_HOST} theme={theme} />}
                {(ui === UI_MYAUDI || ui === UI_MYAUDI_DEALER) && !isIframed &&
                    <Header>{(currentDealer && currentDealer.name) && <>{currentDealer.name}</>}</Header>
                }
                {children}
            </div>
            {(ui === UI_AUDI || ui === UI_AUDI_MIN) && !isIframed && <AudiFooter api={process.env.RAZZLE_CMS_HOST} />}
        </div>
    );
}

export default connect(mapStateToProps)(Layout);
